import React from "react";
import { Link } from "react-router-dom";

export default function() {
  return (
    <footer className="footer">
      <div className="container text-center">
        <div className="text-muted">Todos los derechos reservados.</div>
        <div className="text-muted">
          <Link to="/termsofservice">Términos de Uso</Link>.
        </div>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer.js